import React from "react";
import PropTypes from "prop-types";
import _get from "lodash.get";
import { withRouter } from "react-router-dom";
import { withStyles } from "@mui/styles";

import IconButton from "components/common/IconButton";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "components/common/Stack";
import Grid from "components/common/Grid";
import Radio from "components/common/Radio";
import Text from "components/common/Text";
import JarvisButton from "components/JarvisButton";
import TextField from "components/common/TextField";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import MenuItem from "components/common/MenuItem";
import Card from "components/common/Card";
import Box from "components/common/Box";
import Alert from "components/common/Alert";
import TooltipHover from "components/common/TooltipHover";

import SectionTitle from "components/SectionTitle";
import PaymentSummary from "components/Onboarding/PortfolioCreation/paymentSummary";

import BackIcon from "@mui/icons-material/ArrowBackOutlined";
import CheckIcon from "@mui/icons-material/Check";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

import { config } from "config";
import { validationHelper } from "helper/validation";
import { formatHelper } from "helper/format";
import {
  buildAvailablePlansForSelection,
  pickPortfolioPlanForAmount,
  pickAllInOnePlan,
} from "helper/subscriptionPlan";
import { getAllInOnePreferredFrequency } from "helper/allInOneSignupParams";
import JarvisDialog from "components/JarvisDialog";
import CouponCodeRow from "components/Onboarding/PortfolioCreation/CouponCodeRow";
import OfferBanner from "components/Onboarding/PortfolioCreation/OfferBanner";
import { tracker } from "library/tracker";
import { masterApis } from "stores/master/masterApis";
import { masterParser } from "stores/master/masterParsers";
import Divider from "components/common/Divider";
import ConfirmationActionDialog from "components/ConfirmationActionDialog";
import UpiDrawer from "components/JarvisOnestock/UpiDrawer";
import { localStore } from "stores/localStorage";
import MobileResponsive from "components/common/MobileResponsive";
import Loader from "components/common/Loader";
import Checkbox from "components/common/Checkbox";
import { Dialog, DialogTitle } from "@mui/material";
import Button from "components/common/Button";

const screenTypes = {
  PAYMENT_DETAILS: "PAYMENT_DETAILS",
  PAYMENT_METHOD_CONFIRMATION: "PAYMENT_METHODS_CONFIRMATION",
};

const planFrequencyLabels = {
  MONTHLY: "Monthly",
  HALF_YEARLY: "Half-yearly",
  YEARLY: "Yearly",
  QUARTERLY: "Quarterly",
};

const planTypes = {
  MONTHLY: "month",
  HALF_YEARLY: "Half-yearly",
  QUARTERLY: "four months",
  YEARLY: "Yearly",
};

const planTypes2 = {
  MONTHLY: "months",
  HALF_YEARLY: "Half-yearly",
  QUARTERLY: "four months",
  YEARLY: "Yearly",
};

const confirmationMessage = {
  MONTHLY:
    "Your subscription will renew automatically unless you cancel it on our website. Please keep in mind that you must cancel at least two days before the due date, or your cancellation will take effect after the following payment cycle.",
  HALF_YEARLY:
    "Your subscription will renew automatically from 6 month onwards unless you cancel it on our website. Please keep in mind that you must cancel at least two days before the due date, or your cancellation will take effect after the following payment cycle.",
  YEARLY:
    "Your subscription will renew automatically annually onwards unless you cancel it on our website. Please keep in mind that you must cancel at least two days before the due date, or your cancellation will take effect after the following payment cycle.",
  QUARTERLY:
    "Your subscription will renew automatically from 4 month onwards unless you cancel it on our website. Please keep in mind that you must cancel at least two days before the due date, or your cancellation will take effect after the following payment cycle.",
};

const accountTypes = [
  {
    label: "Savings",
    value: "SAVINGS",
  },
  {
    label: "Current",
    value: "CURRENT",
  },
];

const couponViewTypes = {
  DEFAULT: "DEFAULT",
  EDIT: "EDIT",
  APPLIED: "APPLIED",
};

class PlanPaymentContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeScreenType: screenTypes.PAYMENT_DETAILS,
      selectedPlan: null,
      ssoCustomerDetails: {},
      availablePlans: [],
      confirmationDialogOpen: false,
      isLoading: false,
      error: null,
      upgradedPlanDiscountedPrice: null,
      hasInitializedPlan: false,
      activeProduct: localStorage.getItem("activeProduct") || "",
      formData: {
        planId: "",
        authType: "",
        paymentMethod: "",
        paymentMethodOption: "",
        accountNumber: "",
        accountType: "",
        accountHolderName: "",
        ifscCode: "",
        paymentMethodHandle: "",
      },
      formError: {
        planId: "",
        authType: "",
        paymentMethod: "",
        paymentMethodOption: "",
        accountNumber: "",
        accountType: "",
        accountHolderName: "",
        ifscCode: "",
        paymentMethodHandle: "",
      },
      verifiedUpi: false,
      upiDrawerOpen: false,
      couponActiveViewType: couponViewTypes.DEFAULT,
      confirmCouponDialog: false,
      appliedCouponData: {
        discountType: null,
        discountValue: null,
        discountPrice: null,
        discountedPrice: null,
        isValid: null,
        offerCode: null,
        offerId: null,
        yearlysubcription: null,
        couponDiscount: null,
      },
      couponFormData: {
        coupon: "",
      },
      couponFormError: {
        coupon: "",
      },
      isRecurringCheckBox: true,
      isRecurringModal: false,
      isRecurringLock: false,
      hasAppliedInitialCoupon: false,
      offerBanner: null,
      offerBannerLoading: false,
      offerBannerFetchKey: null,
    };
  }

  setSsoCouponCode = () => {
    const ssoCustomerDetails = localStore.getSsoCustomerDetails();
    const { couponFormData } = this.state;
    couponFormData["coupon"] = ssoCustomerDetails.offerCode;
    this.setState({ couponFormData });
  };

  setInitialCouponCode = () => {
    const { couponFormData } = this.state;
    couponFormData["coupon"] = this.props.initialCouponCode;
    this.setState({ couponFormData });
  };

  static getDerivedStateFromProps(props, state) {
    const {
      subscriptionPlans,
      onboardingPlanId,
      investmentInfo,
      investmentAmount,
      sourceType,
      isAllInOneSubscriptionActive,
      allInOnePlanFrequency,
      productCode,
    } = props;
    const { hasInitializedPlan } = state;

    if (hasInitializedPlan) {
      return null;
    }

    const checkTypeProduct =
      props.isAllInOne ||
      props.productCode === "ALLINONE" ||
      props.productCode === "RMS" ||
      props.productCode === "ONESTOCK" ||
      props.productCode === "SENTIMENT" ||
      props.productCode === "PRIME" ||
      props.productCode === "PORTFOLIO";

    let planId = onboardingPlanId
      ? onboardingPlanId
      : investmentInfo?.planId
        ? investmentInfo?.planId
        : onboardingPlanId;

    if (!subscriptionPlans?.length) {
      return null;
    }

    let selectedPlan = planId
      ? subscriptionPlans.find(
          (plan) => Number(plan.planId) === Number(planId),
        )
      : null;

    const isAllInOneSubscriber =
      sourceType === "ALL_IN_ONE" &&
      (Number(isAllInOneSubscriptionActive) === 1 ||
        isAllInOneSubscriptionActive === true);

    const resolvedProductCode =
      productCode ||
      (props.paymentType === "INITIAL" ? config.productCodes.PORTFOLIO : null);

    if (
      !selectedPlan &&
      (resolvedProductCode === config.productCodes.PORTFOLIO ||
        resolvedProductCode === config.productCodes.PRIME)
    ) {
      selectedPlan = pickPortfolioPlanForAmount(subscriptionPlans, {
        amount: investmentAmount,
        frequency: allInOnePlanFrequency || selectedPlan?.planFrequency,
        preferredPlanId: planId,
      });
      if (selectedPlan) {
        planId = selectedPlan.planId;
      }
    }

    if (isAllInOneSubscriber && allInOnePlanFrequency && selectedPlan) {
      const targetFrequency = String(allInOnePlanFrequency).toUpperCase();
      if (selectedPlan.planFrequency !== targetFrequency) {
        const matchingPlan =
          subscriptionPlans.find(
            (sp) =>
              sp.planFrequency === targetFrequency &&
              sp.planCode === selectedPlan.planCode,
          ) ||
          subscriptionPlans.find(
            (sp) => sp.planFrequency === targetFrequency,
          );
        if (matchingPlan) {
          selectedPlan = matchingPlan;
          planId = selectedPlan.planId;
        }
      }
    } else if (props.isAllInOne) {
      const urlFrequency = getAllInOnePreferredFrequency();
      if (urlFrequency) {
        const matchingPlan = pickAllInOnePlan(subscriptionPlans, {
          planId: selectedPlan?.planId || planId,
          frequency: urlFrequency,
        });
        if (matchingPlan) {
          selectedPlan = matchingPlan;
          planId = selectedPlan.planId;
        }
      }
    }

    if (
      !selectedPlan &&
      (props.paymentType === "INVEST_MORE" || props.investMoreFees)
    ) {
      selectedPlan = subscriptionPlans[0];
      planId = selectedPlan?.planId;
    }

    if (selectedPlan) {
      const availablePlans = buildAvailablePlansForSelection(
        selectedPlan,
        subscriptionPlans,
        {
          isAllInOne: props.isAllInOne,
          isAllInOneSubscriber,
          preferredFrequency: props.isAllInOne
            ? getAllInOnePreferredFrequency()
            : null,
        },
      );

      return {
        selectedPlan,
        availablePlans,
        error: null,
        hasInitializedPlan: true,
        formData: {
          ...state.formData,
          planId,
        },
      };
    }

    return null;
  }

  componentDidMount() {
    this.setState({ ssoCustomerDetails: localStore.getSsoCustomerDetails() });
    const { activeProduct } = this.state;
    const tempActiveProduct = activeProduct
      ?.replace(/^"|"$/g, "")
      ?.trim()
      ?.toUpperCase();

    const checkTypeProduct =
      this.props.isAllInOne ||
      tempActiveProduct == "ALLINONE" ||
      tempActiveProduct == "RMS" ||
      tempActiveProduct == "ONESTOCK" ||
      tempActiveProduct == "SENTIMENT" ||
      tempActiveProduct == "PRIME" ||
      tempActiveProduct == "PORTFOLIO";

    const currentProductCode = this.props.isAllInOne
      ? "ALLINONE"
      : this.props.productCode ||
        (checkTypeProduct ? tempActiveProduct : "PORTFOLIO");

    const shouldFetchPlans =
      !this.props.isSubscriptionPlansCalled ||
      !this.props.subscriptionPlans.some((p) =>
        p.productMap.some((pm) => pm.productCode === currentProductCode),
      );

    if (shouldFetchPlans) {
      this.props.getSubscriptionPlansAction({
        productCode: currentProductCode,
      });
    }

    const planId = checkTypeProduct
      ? this.props.onboardingPlanId
      : this.props.investmentInfo?.planId
        ? this.props.investmentInfo?.planId
        : this.props.onboardingPlanId;

    if (planId && this.props.subscriptionPlans.length) {
      if (this.props.paymentType === "UPGRADE") {
        this.fetchPlanProratedAmount({ planId });
      }
      this.handlePlanChange({ planId });
    }
    if (!this.props.paymentMethods.length) {
      this.props.getPaymentMethodsAction();
    }
    if (!this.props.enableCouponDiscount) {
      this.props.getFeatureConfigAction();
    }
    if (this.state.activeScreenType === screenTypes.PAYMENT_DETAILS) {
      const appContentBody = document.getElementById("appContentBody");
      if (appContentBody) {
        appContentBody.scrollTop = 0;
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      onboardingPlanId,
      subscriptionPlans,
      investmentInfo,
      productCode,
      investmentAmount,
    } = this.props;

    if (prevProps.productCode !== productCode) {
      this.props.getSubscriptionPlansAction({
        productCode: productCode,
      });
    }
    const {
      hasInitializedPlan,
      selectedPlan,
      hasAppliedSsoCoupon,
      ssoCustomerDetails,
      activeProduct,
    } = this.state;

    let tempActiveProduct = "";
    try {
      tempActiveProduct = JSON.parse(activeProduct);
    } catch (e) {
      tempActiveProduct = activeProduct
        ?.replace(/^"|"$/g, "")
        ?.trim()
        ?.toUpperCase();
    }

    const checkTypeProduct =
      this.props.isAllInOne ||
      [
        "ALLINONE",
        "RMS",
        "ONESTOCK",
        "SENTIMENT",
        "PRIME",
        "PORTFOLIO",
      ].includes(productCode || tempActiveProduct);

    const planId = checkTypeProduct
      ? onboardingPlanId
      : investmentInfo?.planId
        ? investmentInfo?.planId
        : onboardingPlanId;

    if (planId && subscriptionPlans.length && !hasInitializedPlan) {
      const planExists = subscriptionPlans.some(
        (sp) => Number(sp.planId) === Number(planId),
      );
      if (
        planExists ||
        this.props.paymentType === "INVEST_MORE" ||
        this.props.investMoreFees
      ) {
        // Prevent infinite loop by using a callback version of setState
        this.setState({ hasInitializedPlan: true }, () => {
          this.handlePlanChange({ planId });
          if (this.props.paymentType === "UPGRADE") {
            this.fetchPlanProratedAmount({ planId });
          }
        });
      } else {
        const fallbackPlan = pickPortfolioPlanForAmount(subscriptionPlans, {
          amount: investmentAmount,
          frequency: this.props.allInOnePlanFrequency,
          preferredPlanId: planId,
        });

        if (fallbackPlan) {
          this.setState({ hasInitializedPlan: true, error: null }, () => {
            this.handlePlanChange({ planId: fallbackPlan.planId });
            this.props.updateOnboardingDataAction?.({
              planId: fallbackPlan.planId,
            });
            if (this.props.paymentType === "UPGRADE") {
              this.fetchPlanProratedAmount({ planId: fallbackPlan.planId });
            }
          });
        } else if (
          prevState.error !== "Invalid plan selected. Please try again."
        ) {
          this.setState({ error: "Invalid plan selected. Please try again." });
        }
      }
    }

    if (
      this.state.selectedPlan &&
      !this.state.availablePlans?.length &&
      subscriptionPlans.length
    ) {
      this.handlePlanChange({ planId: this.state.selectedPlan.planId });
    }

    const resolvedProductCode =
      productCode || tempActiveProduct || config.productCodes.PORTFOLIO;

    if (
      !hasInitializedPlan &&
      subscriptionPlans.length &&
      !selectedPlan &&
      (resolvedProductCode === config.productCodes.PORTFOLIO ||
        resolvedProductCode === config.productCodes.PRIME)
    ) {
      const fallbackPlan = pickPortfolioPlanForAmount(subscriptionPlans, {
        amount: investmentAmount,
        frequency: this.props.allInOnePlanFrequency,
        preferredPlanId: onboardingPlanId,
      });

      if (fallbackPlan) {
        this.setState({ hasInitializedPlan: true, error: null }, () => {
          this.handlePlanChange({ planId: fallbackPlan.planId });
          this.props.updateOnboardingDataAction?.({
            planId: fallbackPlan.planId,
          });
        });
      } else {
        this.setState({
          hasInitializedPlan: true,
          error: "Unable to load subscription plan. Please go back and try again.",
        });
      }
    }

    if (
      !hasInitializedPlan &&
      !this.props.isSubscriptionPlansLoading &&
      this.props.isSubscriptionPlansCalled &&
      !subscriptionPlans.length
    ) {
      this.setState({
        hasInitializedPlan: true,
        error: "Unable to load subscription plans. Please try again.",
      });
    }

    // Apply SSO coupon only once
    if (
      selectedPlan &&
      prevState.selectedPlan === null &&
      ssoCustomerDetails?.offerCode &&
      !hasAppliedSsoCoupon
    ) {
      this.setState({ hasAppliedSsoCoupon: true }, () => {
        this.setSsoCouponCode();
        this.handleCouponSubmit();
      });
    }

    // Apply Initial All-in-One coupon only once
    if (
      this.props.isAllInOne &&
      this.props.initialCouponCode &&
      selectedPlan &&
      !this.state.hasAppliedInitialCoupon
    ) {
      this.setState({ hasAppliedInitialCoupon: true }, () => {
        this.setInitialCouponCode();
        this.handleCouponSubmit();
      });
    }

    // Force plan frequency selection matching allInOnePlanFrequency for active All-In-One subscribers
    const isAllInOneSubscriber =
      this.props.sourceType === "ALL_IN_ONE" &&
      (Number(this.props.isAllInOneSubscriptionActive) === 1 ||
        this.props.isAllInOneSubscriptionActive === true);
    if (
      isAllInOneSubscriber &&
      this.props.allInOnePlanFrequency &&
      selectedPlan &&
      (prevProps.allInOnePlanFrequency !== this.props.allInOnePlanFrequency ||
        prevProps.isAllInOneSubscriptionActive !==
          this.props.isAllInOneSubscriptionActive ||
        prevProps.sourceType !== this.props.sourceType ||
        prevState.selectedPlan === null)
    ) {
      const targetFrequency = String(
        this.props.allInOnePlanFrequency,
      ).toUpperCase();
      if (selectedPlan.planFrequency !== targetFrequency) {
        const matchingPlan =
          subscriptionPlans.find(
            (sp) =>
              sp.planFrequency === targetFrequency &&
              sp.planCode === selectedPlan.planCode,
          ) ||
          subscriptionPlans.find((sp) => sp.planFrequency === targetFrequency);
        if (matchingPlan) {
          this.handlePlanChange({ planId: matchingPlan.planId });
        }
      }
    }
  }

  fetchPlanProratedAmount = async ({
    customerId = "",
    planId = "",
    investMoreAmount = "",
  }) => {
    const plan = this.props.subscriptionPlans?.find(
      (sp) => Number(sp.planId) === Number(planId),
    );
    if (!plan) {
      this.setState({ error: "Plan not found. Please try again." });
      return;
    }
    const productCode = plan.productMap?.[0]?.productCode;
    if (!planId || !productCode) {
      this.setState({ error: "Invalid plan data. Please try again." });
      return;
    }
    this.setState({ isLoading: true });
    let payload = { planId, productCode };
    if (investMoreAmount) {
      payload.investMoreAmount = investMoreAmount;
    }
    try {
      const response =
        await masterApis.fetchPlanDiscountedPriceOnUpgrade(payload);

      const parsedResponse =
        masterParser.fetchPlanDiscountedPriceOnUpgrade(response);

      if (
        parsedResponse?.finalPlanAmount &&
        parsedResponse.finalPlanAmount > 0
      ) {
        this.setState({
          upgradedPlanDiscountedPrice: parsedResponse.finalPlanAmount,
        });
      } else if (
        parsedResponse?.finalPlanAmount &&
        parsedResponse.finalPlanAmount < 0
      ) {
        this.state({
          error:
            "The calculated price is invalid. Please refresh and try again.",
        });
      } else {
        this.setState({ upgradedPlanDiscountedPrice: plan.planPrice || 0 });
      }
    } catch (error) {
      this.setState({
        upgradedPlanDiscountedPrice: plan.planPrice || 0,
        activeScreenType: screenTypes.PAYMENT_DETAILS,
      });
      this.props.navigatePreviousScreen?.();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  fetchCampaignAppliedOffer = async ({ plan }) => {
    if (!this.props.enableCouponDiscount) return;
    if (
      !plan ||
      !Array.isArray(plan.productMap) ||
      plan.productMap.length === 0
    ) {
      return;
    }
    const productCode = plan.productMap[0]?.productCode;
    if (!productCode) {
      return;
    }
    try {
      const isInvestMore =
        this.props.paymentType === "INVEST_MORE" || this.props.investMoreFees;
      const response = await masterApis.getAppliedCampaignOffer({
        productCode,
        planId: plan.planId,
        offerType:
          this.props.paymentType === "INVEST_MORE"
            ? "INITIAL"
            : this.props.paymentType,
        customerValueAddedPlanId: isInvestMore
          ? this.props.customerValueAddedPlanId
          : undefined,
      });
      const parsedResponse = masterParser.validateOffer(response);

      this.setState({
        appliedCouponData: parsedResponse,
        couponActiveViewType: parsedResponse.isValid
          ? couponViewTypes.APPLIED
          : couponViewTypes.DEFAULT,
      });
      tracker.coupon.applySuccess();
    } catch (error) {
      tracker.coupon.applyFailed({ error_msg: error.message });
    }
  };

  fetchOfferBanner = ({ plan }) => {
    if (this.props.isAllInOne) {
      return;
    }
    if (!plan || !plan.planId) {
      return;
    }
    const productCode = plan.productMap?.[0]?.productCode;
    if (!productCode) {
      return;
    }

    const fetchKey = `${productCode}:${plan.planId}`;
    if (fetchKey === this._offerBannerFetchKey) {
      return;
    }
    this._offerBannerFetchKey = fetchKey;

    this.setState({
      offerBannerLoading: true,
      offerBannerFetchKey: fetchKey,
      offerBanner: null,
    });

    masterApis
      .getPaymentOfferBanner({
        productCode,
        planId: plan.planId,
      })
      .then((response) => {
        if (this._offerBannerFetchKey !== fetchKey) {
          return;
        }
        const banner = masterParser.parsePaymentOfferBanner(response);
        this.setState({
          offerBanner: banner && banner.title ? banner : null,
          offerBannerLoading: false,
        });
      })
      .catch(() => {
        if (this._offerBannerFetchKey !== fetchKey) {
          return;
        }
        this.setState({
          offerBanner: null,
          offerBannerLoading: false,
        });
      });
  };

  renderOfferBanner = () => {
    if (this.props.isAllInOne) {
      return null;
    }
    if (this.state.offerBannerLoading) {
      return <Box sx={{ minHeight: 108, mb: 2 }} />;
    }
    if (!this.state.offerBanner) {
      return null;
    }
    return <OfferBanner data={this.state.offerBanner} />;
  };

  handlePlanChange = ({ planId }) => {
    const { subscriptionPlans, investmentInfo } = this.props;
    let tempActiveProduct = "";
    try {
      tempActiveProduct = JSON.parse(this.state.activeProduct);
    } catch (e) {
      tempActiveProduct = this.state.activeProduct
        ?.replace(/^"|"$/g, "")
        ?.trim()
        ?.toUpperCase();
    }

    const checkTypeProduct =
      this.props.isAllInOne ||
      [
        "ALLINONE",
        "RMS",
        "ONESTOCK",
        "SENTIMENT",
        "PRIME",
        "PORTFOLIO",
      ].includes(this.props.productCode || tempActiveProduct);

    let tempPlanId = checkTypeProduct ? planId : investmentInfo?.planId;

    if (!tempPlanId) {
      this.setState({ error: "Unable to load plan data. Please try again." });
      return;
    }

    if (!subscriptionPlans.length) {
      return;
    }

    const isAllInOneSubscriber =
      this.props.sourceType === "ALL_IN_ONE" &&
      (Number(this.props.isAllInOneSubscriptionActive) === 1 ||
        this.props.isAllInOneSubscriptionActive === true);
    if (isAllInOneSubscriber && this.props.allInOnePlanFrequency) {
      const targetFrequency = String(
        this.props.allInOnePlanFrequency,
      ).toUpperCase();
      let currentPlan = subscriptionPlans.find(
        (sp) => Number(sp.planId) === Number(tempPlanId),
      );
      if (currentPlan && currentPlan.planFrequency !== targetFrequency) {
        const matchingPlan =
          subscriptionPlans.find(
            (sp) =>
              sp.planFrequency === targetFrequency &&
              sp.planCode === currentPlan.planCode,
          ) ||
          subscriptionPlans.find((sp) => sp.planFrequency === targetFrequency);
        if (matchingPlan) {
          tempPlanId = matchingPlan.planId;
        }
      }
    }

    console.log("subscriptionPlans", subscriptionPlans);
    let plan = subscriptionPlans.find(
      (sp) => Number(sp.planId) === Number(tempPlanId),
    );

    if (
      !plan &&
      (this.props.paymentType === "INVEST_MORE" || this.props.investMoreFees)
    ) {
      plan = subscriptionPlans[0];
      tempPlanId = plan?.planId;
    }

    if (
      !plan &&
      (this.props.productCode === config.productCodes.PORTFOLIO ||
        this.props.productCode === config.productCodes.PRIME ||
        tempActiveProduct === config.productCodes.PORTFOLIO ||
        tempActiveProduct === config.productCodes.PRIME)
    ) {
      plan = pickPortfolioPlanForAmount(subscriptionPlans, {
        amount: this.props.investmentAmount,
        frequency: this.props.allInOnePlanFrequency,
        preferredPlanId: tempPlanId,
      });
      tempPlanId = plan?.planId;
      if (plan && this.props.updateOnboardingDataAction) {
        this.props.updateOnboardingDataAction({ planId: plan.planId });
      }
    }

    if (!plan) {
      this.setState({ error: "Invalid plan selected. Please try again." });
      return;
    }

    const productCode = plan.productMap?.[0]?.productCode;
    let availablePlans = buildAvailablePlansForSelection(
      plan,
      subscriptionPlans,
      {
        isAllInOne: this.props.isAllInOne,
        isAllInOneSubscriber,
        preferredFrequency: this.props.isAllInOne
          ? getAllInOnePreferredFrequency()
          : null,
      },
    );

    if (this.props.isAllInOne) {
      this.setState(
        {
          appliedCouponData: {
            discountType: null,
            discountValue: null,
            discountPrice: null,
            discountedPrice: null,
            isValid: null,
            offerCode: null,
            offerId: null,
            yearlysubcription: null,
            couponDiscount: null,
          },
          selectedPlan: plan,
          couponActiveViewType: couponViewTypes.DEFAULT,
          availablePlans,
          error: null,
        },
        () => {
          this.setState({ isLoading: true }, async () => {
            try {
              await this.fetchCampaignAppliedOffer({ plan });
              if (this.props.initialCouponCode) {
                await this.handleCouponSubmit();
              }
            } catch (err) {
              console.error("All-In-One plan change async failed", err);
            } finally {
              this.setState({ isLoading: false });
            }
          });
        },
      );
    } else {
      this.fetchCampaignAppliedOffer({ plan });
      this.fetchOfferBanner({ plan });

      this.setState(
        {
          appliedCouponData: {
            discountType: null,
            discountValue: null,
            discountPrice: null,
            discountedPrice: null,
            isValid: null,
            offerCode: null,
            offerId: null,
            yearlysubcription: null,
            couponDiscount: null,
          },
          selectedPlan: plan,
          couponActiveViewType: couponViewTypes.DEFAULT,
          availablePlans,
          error: null, // Clear any previous errors
        },
        () => {
          // Re-apply the ALL_IN_ONE coupon automatically for the newly selected plan
          if (this.props.isAllInOne && this.props.initialCouponCode) {
            this.handleCouponSubmit();
          }
        },
      );
    }

    this.handleFormChange({ name: "planId", value: tempPlanId });
  };

  isTPVEnabled = () => this.props.enableRazorpayTPV;

  handleFormChange = ({ name, value }) => {
    const { formData } = this.state;
    if (name === "paymentMethod" && formData.paymentMethod !== value) {
      formData[name] = value;
      formData["paymentMethodOption"] = "";
      formData["paymentMethodHandle"] = "";
      formData["authType"] = "";
      if (!this.isTPVEnabled()) {
        formData["accountNumber"] = "";
        formData["accountType"] = "";
        formData["accountHolderName"] = "";
        formData["ifscCode"] = "";
      }
    } else {
      formData[name] = value;
    }
    this.setState({ formData, verifiedUpi: false });
  };

  handleBackClick = () => {
    this.setState({
      activeScreenType: screenTypes.PAYMENT_DETAILS,
      verifiedUpi: false,
    });
  };

  handleContinuePayment = () => {
    if (this.props.oneTimePayment) {
      this.oneTimePaymentHandler();
    } else {
      if (this.props.byPassRecurringPayment) {
        return this.handlePayNowByPassRecurring();
      } else {
        this.setState({
          activeScreenType: screenTypes.PAYMENT_METHOD_CONFIRMATION,
        });
        const { customerProfile } = this.props;
        const { selectedPlan } = this.state;
        const productCode = selectedPlan.productMap[0].productCode;

        if (customerProfile[productCode].paymentMethod !== "ONETIME") {
          if (this.state.couponActiveViewType === couponViewTypes.EDIT) {
            return this.setState({ confirmCouponDialog: true });
          }
          return this.setState({
            activeScreenType: screenTypes.PAYMENT_METHOD_CONFIRMATION,
          });
        }
        return this.handlePayNow();
      }
    }
  };

  handleValidation = () => {
    const { formError, formData } = this.state;
    let invalidCount = 0;

    const paymentMethodValidation = validationHelper.required(
      formData.paymentMethod,
    );
    formError.paymentMethod = paymentMethodValidation.message;
    invalidCount = invalidCount + (paymentMethodValidation.isValid ? 0 : 1);

    if (formData.paymentMethod === "emandate") {
      const paymentMethodOptionValidation = validationHelper.required(
        formData.paymentMethodOption,
      );
      formError.paymentMethodOption = paymentMethodOptionValidation.message;
      invalidCount =
        invalidCount + (paymentMethodOptionValidation.isValid ? 0 : 1);
    }

    if (this.isTPVEnabled() || formData.paymentMethod === "emandate") {
      const nameValidation = validationHelper.name(formData.accountHolderName);
      formError.accountHolderName = nameValidation.message;
      invalidCount = invalidCount + (nameValidation.isValid ? 0 : 1);

      const ifscValidation = validationHelper.ifscCode(formData.ifscCode);
      formError.ifscCode = ifscValidation.message;
      invalidCount = invalidCount + (ifscValidation.isValid ? 0 : 1);

      const accountNumberValidation = validationHelper.bankAccountNumber(
        formData.accountNumber,
      );
      formError.accountNumber = accountNumberValidation.message;
      invalidCount = invalidCount + (accountNumberValidation.isValid ? 0 : 1);
    }

    if (formData.paymentMethod === "emandate") {
      const authTypeValidation = validationHelper.required(formData.authType);
      formError.authType = authTypeValidation.message;
      invalidCount = invalidCount + (authTypeValidation.isValid ? 0 : 1);
    }

    this.setState({ formError });
    return invalidCount === 0;
  };

  handlePayNow = () => {
    const { customerProfile } = this.props;
    const { selectedPlan } = this.state;
    const productCode = selectedPlan.productMap[0].productCode;
    if (!this.handleValidation()) {
      return;
    }
    const { formData, appliedCouponData } = this.state;
    let paymentMethod = "upi";
    paymentMethod = formData.paymentMethod;
    const payload = {
      planId: formData.planId,
      paymentMethod,
    };

    if (formData.paymentMethod === "upi") {
      payload["paymentMethodOption"] = formData.paymentMethodHandle;
    }

    if (formData.paymentMethod === "emandate") {
      payload["paymentMethodOption"] = formData.paymentMethodOption;
    }

    if (appliedCouponData.isValid) {
      payload["offerCode"] = appliedCouponData.offerCode;
    }

    if (formData.paymentMethod === "emandate") {
      payload["authType"] = formData.authType;
    }

    if (this.isTPVEnabled() || formData.paymentMethod === "emandate") {
      payload["accountNumber"] = formData.accountNumber;
      payload["accountType"] = formData.accountType;
      payload["accountHolderName"] = formData.accountHolderName;
      payload["ifscCode"] = formData.ifscCode;
    }
    this.props.onPayNowClick(payload);
  };

  handlePayNowByPassRecurring = () => {
    const { formData, appliedCouponData } = this.state;
    let paymentMethod = "upi";
    const payload = {
      planId: formData.planId,
      paymentMethod,
    };

    if (appliedCouponData.isValid) {
      payload["offerCode"] = appliedCouponData.offerCode;
    }

    this.props.onPayNowClick(payload);
  };

  handleUpiVerification = () => {
    const { formData, formError } = this.state;
    if (
      this.props.paymentMethods.eligibleUpiHandles.includes(
        `@${formData.paymentMethodHandle.split("@")[1]}`,
      )
    ) {
      this.setState({ verifiedUpi: true, formError: {} });
    } else {
      if (formData.paymentMethodHandle === "") {
        formError.paymentMethodHandle = "This field is required";
        this.setState({ formError });
      } else if (!formData.paymentMethodHandle.includes("@")) {
        formError.paymentMethodHandle = "Invalid UPI";
        this.setState({ formError });
      } else {
        formError.paymentMethodHandle = "UPI handle not supported for autopay";
        this.setState({ formError });
      }
    }
  };

  getPlanType = (val) => {
    return planFrequencyLabels[val];
  };

  handleCancel = () => {
    this.setState({ confirmationDialogOpen: false });
  };

  handleConfirm = () => {
    this.setState({
      confirmationDialogOpen: false,
      activeScreenType: screenTypes.PAYMENT_METHOD_CONFIRMATION,
    });
  };

  handleCouponChange = ({ name, value }) => {
    const { couponFormData } = this.state;
    couponFormData[name] = value;
    this.setState({ couponFormData });
  };

  handleCouponFormValidation = () => {
    const { couponFormData, couponFormError } = this.state;
    const couponValidation = validationHelper.required(couponFormData.coupon);
    couponFormError.coupon = couponValidation.message;
    this.setState({ couponFormError });
    return couponValidation.isValid;
  };

  handleCouponSubmit = async () => {
    tracker.coupon.apply();
    if (
      !this.props.enableCouponDiscount ||
      !this.handleCouponFormValidation()
    ) {
      return;
    }
    try {
      const { couponFormData, selectedPlan } = this.state;
      let productCode = this.props.isAllInOne
        ? "ALL_IN_ONE"
        : this.state.ssoCustomerDetails?.productCode?.toUpperCase() ||
          selectedPlan.productMap?.[0]?.productCode;
      const isInvestMore =
        this.props.paymentType === "INVEST_MORE" || this.props.investMoreFees;
      const response = await masterApis.validateOffer({
        productCode,
        offerCode: couponFormData.coupon,
        planId: selectedPlan.planId,
        offerType:
          this.props.paymentType === "INVEST_MORE"
            ? "INITIAL"
            : this.props.paymentType,
        customerValueAddedPlanId: isInvestMore
          ? this.props.customerValueAddedPlanId
          : undefined,
      });

      const parsedResponse = masterParser.validateOffer(response);

      if (
        !parsedResponse.discountedPrice ||
        parsedResponse.discountedPrice <= 0
      ) {
        console.warn(
          "Invalid coupon discountedPrice, resetting appliedCouponData",
        );
        parsedResponse.isValid = false;
        parsedResponse.discountedPrice = selectedPlan.planPrice || 0;
      }
      this.setState({
        appliedCouponData: parsedResponse,
        couponActiveViewType: parsedResponse.isValid
          ? couponViewTypes.APPLIED
          : couponViewTypes.DEFAULT,
      });
      tracker.coupon.applySuccess();
    } catch (error) {
      tracker.coupon.applyFailed({ error_msg: error.message });
      console.error("Error fetching coupon data", error);
    }
  };

  handleCouponAction = (action, payload) => {
    switch (action) {
      case "COUPON_ADD":
        tracker.coupon.apply();
        this.setState({
          couponActiveViewType: couponViewTypes.EDIT,
          couponFormData: { coupon: "" },
          couponFormError: { coupon: "" },
        });
        break;
      case "COUPON_CLEAR":
        this.setState({
          couponActiveViewType: couponViewTypes.DEFAULT,
          couponFormData: { coupon: "" },
          couponFormError: { coupon: "" },
          appliedCouponData: {
            discountType: null,
            discountValue: null,
            discountPrice: null,
            discountedPrice: null,
            isValid: null,
            offerCode: null,
            offerId: null,
            yearlysubcription: null,
            couponDiscount: null,
          },
        });
        break;
      case "COUPON_SUBMIT":
        this.handleCouponSubmit();
        break;
      case "COUPON_CHANGE":
        this.handleCouponChange(payload);
        break;
      default:
        console.log(`${action} is not defined`);
        break;
    }
  };

  handleUpiDrawerOpen = () => {
    this.setState({ upiDrawerOpen: true });
  };

  handleUpiDrawerClose = () => {
    this.setState({ upiDrawerOpen: false });
  };

  handleCheckBox = (e) => {
    const { isRecurringCheckBox } = this.state;
    this.setState({
      isRecurringCheckBox: !isRecurringCheckBox,
      isRecurringModal: true,
    });
  };

  handleEnableEMandate = () => {
    this.setState({
      isRecurringCheckBox: true,
      isRecurringModal: false,
      isRecurringLock: false,
    });
  };

  SkipForNowHandler = () => {
    this.setState({ isRecurringLock: true, isRecurringModal: false });
  };

  oneTimePaymentHandler = () => {
    const { formData, appliedCouponData } = this.state;
    let paymentMethod = "upi";
    const isOnetime = true;
    const payload = {
      planId: formData.planId,
      paymentMethod,
    };

    if (this.props.paymentType === "INVEST_MORE" || this.props.isAllInOne) {
      payload["transactionType"] = this.props.isAllInOne
        ? "ALL_IN_ONE"
        : "INVEST_MORE";
      payload["customerValueAddedPlanId"] = this.props.customerValueAddedPlanId;
    }

    if (appliedCouponData.isValid) {
      payload["offerCode"] = appliedCouponData.offerCode;
    }
    this.props.onPayNowClick(payload, isOnetime);
  };

  render() {
    const {
      activeScreenType,
      selectedPlan,
      availablePlans,
      formData,
      formError,
      confirmationDialogOpen,
      upiDrawerOpen,
      upgradedPlanDiscountedPrice,
      isLoading,
      isRecurringCheckBox,
      isRecurringModal,
      isRecurringLock,
      error,
      hasInitializedPlan,
    } = this.state;

    const { subscriptionPlans, isSubscriptionPlansLoading } = this.props;

    if (error) {
      return <Alert severity="error">{error}</Alert>;
    }

    if (isLoading) {
      return <Loader position="fixed" size="lg" loading={true} />;
    }

    if (!selectedPlan) {
      if (isSubscriptionPlansLoading || !hasInitializedPlan) {
        return <Loader position="fixed" size="lg" loading={true} />;
      }

      return (
        <Alert severity="error">
          Unable to load subscription plan. Please go back and try again.
        </Alert>
      );
    }

    const activeProductCode = this.state.activeProduct
      ?.replace(/^"|"$/g, "")
      ?.trim()
      ?.toUpperCase();

    let payableAmount =
      this.props.paymentType === "UPGRADE" && upgradedPlanDiscountedPrice
        ? upgradedPlanDiscountedPrice
        : this.props.investMoreFees
          ? this.props.investMoreFees
          : activeProductCode === "PRIME" && selectedPlan?.planPriceTotal
            ? selectedPlan.planPriceTotal
            : selectedPlan?.planPrice || 0;
    if (
      selectedPlan?.planDiscountedPrice &&
      selectedPlan.planDiscountedPrice > 0
    ) {
      payableAmount = selectedPlan.planDiscountedPrice;
    }
    if (
      this.state.appliedCouponData.isValid &&
      this.state.appliedCouponData.discountedPrice > 0
    ) {
      payableAmount = this.state.appliedCouponData.discountedPrice;
    }

    // this.state.appliedCouponData.discountPrice

    const {
      paymentMethods,
      disableBackFromPaymentDetails = false,
      paymentType,
    } = this.props;

    const isExclGST = activeProductCode;
    console.log(this.state.couponFormData.coupon, "appliedCouponData");

    if (activeScreenType === screenTypes.PAYMENT_DETAILS) {
      return (
        <Stack sx={{ mb: { xs: 8, md: 0 } }}>
          <SectionTitle
            sx={{ mb: 2 }}
            showBestValue={this.props.isAllInOne}
            heading={
              this.props.isAllInOne
                ? "Unlock More Value with our ALL- In- ONE Offer"
                : "Payment"
            }
            disableBreadcrumb
            startIcon={
              !this.props.isAllInOne &&
              !disableBackFromPaymentDetails && (
                <IconButton onClick={this.props.navigatePreviousScreen}>
                  <BackIcon sx={{ fontSize: 20, color: "#222B3E" }} />
                </IconButton>
              )
            }
          />
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5}>
              {availablePlans.length > 1 ? (
              <Stack direction="row" alignItems="center" mb={4}>
                {availablePlans.map((p) => {
                  const isAllInOneSubscriber =
                    this.props.sourceType === "ALL_IN_ONE" &&
                    (Number(this.props.isAllInOneSubscriptionActive) === 1 ||
                      this.props.isAllInOneSubscriptionActive === true);
                  const urlFrequency = this.props.isAllInOne
                    ? getAllInOnePreferredFrequency()
                    : null;
                  const targetFrequency = this.props.allInOnePlanFrequency
                    ? String(this.props.allInOnePlanFrequency).toUpperCase()
                    : urlFrequency || "";
                  const isDisabled =
                    (isAllInOneSubscriber || Boolean(urlFrequency)) &&
                    targetFrequency &&
                    p.planFrequency !== targetFrequency;

                  return (
                    <Stack
                      direction="row"
                      alignItems="center"
                      key={p.planId}
                      mr={3}
                    >
                      <Radio
                        checked={p.planFrequency === selectedPlan.planFrequency}
                        disabled={isDisabled}
                        onChange={() =>
                          this.handlePlanChange({ planId: p.planId })
                        }
                      />
                      <Text sx={{ opacity: isDisabled ? 0.5 : 1 }}>
                        {planFrequencyLabels[p.planFrequency] || "Half-yearly"}
                      </Text>
                    </Stack>
                  );
                })}
              </Stack>
              ) : null}
              <Card
                sx={{
                  border: "1px solid #E4E6E8",
                  boxShadow: "none",
                  marginBottom: "40px",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  sx={{
                    background: "rgba(49, 142, 52, 0.12)",
                    borderRadius: "4px 4px 0px 0px",
                  }}
                  py={1.5}
                  px={3}
                >
                  <Text
                    variant="small"
                    color={"success.light"}
                    sx={{ fontWeight: "medium" }}
                  >
                    Selected Plan
                  </Text>
                </Stack>
                <Stack my={3} mx={3}>
                  <Box>
                    <Text variant="subtitle1" sx={{ fontSize: "500" }}>
                      {selectedPlan?.planName}
                    </Text>
                    {selectedPlan?.planPrice &&
                    selectedPlan?.planDiscountPercentage ? (
                      <Stack>
                        <Stack direction="row" alignItems="flex-end">
                          <Text
                            sx={{
                              lineHeight: "1.1",
                              fontSize: "subtitle1.fontSize",
                              fontWeight: "600",
                            }}
                          >
                            {formatHelper.currency(
                              selectedPlan?.planDiscountedPrice,
                            )}
                            &nbsp;
                          </Text>
                          <Text
                            sx={{
                              color: "#676E76",
                              fontSize: "small.fontSize",
                            }}
                          >
                            <span style={{ textDecoration: "line-through" }}>
                              {formatHelper.currency(payableAmount)}
                            </span>
                            &nbsp;for the first{" "}
                            {formatHelper.getPaymentFrequencyLabel(
                              selectedPlan?.planFrequency,
                            )}
                          </Text>
                        </Stack>
                        <Text
                          sx={{ color: "#676E76", fontSize: "small.fontSize" }}
                        >
                          and {formatHelper.currency(payableAmount)} for the
                          subsequent{" "}
                          {formatHelper.getPaymentFrequencyLabel(
                            selectedPlan?.planFrequency,
                          )}
                        </Text>
                        <Text>
                          {isExclGST === "PRIME" ? "incl. GST" : "Incl. GST"}
                        </Text>
                      </Stack>
                    ) : (
                      <Stack>
                        <Stack direction="row" alignItems="center">
                          <Text
                            sx={{
                              lineHeight: "1.1",
                              fontSize: "32px",
                              fontWeight: "600",
                              marginRight: "5px",
                            }}
                          >
                            {formatHelper.currency(payableAmount)}
                          </Text>
                          /.
                          {formatHelper.getPaymentFrequencyLabel(
                            selectedPlan?.planFrequency,
                          )}
                        </Stack>
                        <Text>
                          {isExclGST === "PRIME" ? "Incl. GST" : "Incl. GST"}
                        </Text>
                      </Stack>
                    )}
                  </Box>
                </Stack>
              </Card>
              <Stack sx={{ flex: 1, mb: { xs: 2, md: 1 } }}>
                <Text variant="body1" sx={{ fontWeight: "medium", mb: 2 }}>
                  Your subscription unlocks
                </Text>
                {selectedPlan?.planChecklist.map((check, index) => (
                  <Stack
                    key={`check_${index}`}
                    direction="row"
                    alignItems="flex-start"
                    sx={{ mb: 1 }}
                  >
                    <CheckIcon
                      sx={{ fontSize: 16, color: "#45AC70", mr: 1, mt: 0.45 }}
                    />
                    <Text variant="body2">{check}</Text>
                  </Stack>
                ))}
              </Stack>
            </Grid>
            <Grid item xs={12} md={5}>
              {this.props.enableCouponDiscount ? (
                <>
                  <CouponCodeRow
                    percentageOff={this.state.appliedCouponData?.percentageOff}
                    onActionTrigger={this.handleCouponAction}
                    viewTypes={couponViewTypes}
                    activeViewType={this.state.couponActiveViewType}
                    formData={this.state.couponFormData}
                    formError={this.state.couponFormError}
                    discountValue={this.state.appliedCouponData.discountPrice}
                    selectedPlanType={selectedPlan}
                    disableRemoveCoupon={this.props.isAllInOne}
                    propsValue={this.props}
                  />
                  <Divider sx={{ my: 2 }} />
                </>
              ) : null}
              {this.renderOfferBanner()}
              <Text
                variant="body1"
                sx={{ fontWeight: "medium", mb: {    xs: 2, md: 1 } }}
              >
                Price details
              </Text>
              <PaymentSummary
                isAllInOne={this.props.isAllInOne}
                selectedPlan={selectedPlan}
                planType={this.getPlanType(selectedPlan?.planFrequency)}
                appliedCouponData={this.state.appliedCouponData}
                paymentType={paymentType}
                upgradePlanAmount={
                  upgradedPlanDiscountedPrice || this.props.investMoreFees || ""
                }
              />
              <Stack
                sx={{
                  background: "unset",
                  width: { xs: "100%", md: "unset" },
                  justifyContent: { xs: "center", md: "unset" },
                  alignItems: { xs: "center", md: "unset" },
                }}
              >
                <Stack
                  sx={{
                    position: { xs: "fixed", md: "unset" },
                    bottom: { xs: "0px", md: "unset" },
                    width: { xs: "100%", md: "unset" },
                    backgroundColor: { xs: "unset", md: "none" },
                    padding: { xs: "10px 14px", md: "0px" },
                    paddingBottom: {
                      xs: "calc(var(--safe-area-inset-bottom) + 12px) !important",
                    },
                  }}
                >
                  <JarvisButton
                    sx={{ marginBottom: 2 }}
                    variant="contained"
                    disableEndIcon
                    onClick={() => {
                      if (this.props.byPassRecurringPayment) {
                        this.handleContinuePayment();
                      } else {
                        if (
                          this.state.couponActiveViewType ===
                          couponViewTypes.EDIT
                        ) {
                          this.setState({
                            activeScreenType:
                              screenTypes.PAYMENT_METHOD_CONFIRMATION,
                          });
                        } else {
                          this.handleContinuePayment();
                        }
                      }
                    }}
                  >
                    Continue to payment
                  </JarvisButton>
                  <Text
                    sx={{
                      display: { md: "block", xs: "block" },
                      textAlign: "center",
                    }}
                    variant="caption1"
                  >
                    {this.props.byPassRecurringPayment || this.props.isAllInOne
                      ? null
                      : `Your subscription auto-renews every month. You can cancel
                    subscription any time.`}
                  </Text>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
          <ConfirmationActionDialog
            open={this.state.confirmCouponDialog}
            onConfirm={() => {
              this.setState({ confirmCouponDialog: false }, () => {
                this.handleContinuePayment();
              });
            }}
            onClose={() => this.setState({ confirmCouponDialog: false })}
            message={"Would you like to continue without a coupon discount?"}
          />
        </Stack>
      );
    }

    if (activeScreenType === screenTypes.PAYMENT_METHOD_CONFIRMATION) {
      const selectedPaymentMethodData =
        paymentMethods.eligiblePaymentMethods.find(
          (emp) => emp.value === formData.paymentMethod,
        ) || {};
      const paymentMethodOptions = _get(
        paymentMethods,
        `${selectedPaymentMethodData.value}Options`,
        [],
      );
      const selectedMethodOptionData =
        paymentMethodOptions.find(
          (pmo) => pmo.value === formData.paymentMethodOption,
        ) || {};
      const authTypeOptions = paymentMethods.eligibleAuthTypes.filter(
        (eat) =>
          selectedMethodOptionData.supportedAuthTypes &&
          selectedMethodOptionData.supportedAuthTypes.includes(eat.value),
      );

      return (
        <Stack>
          <SectionTitle
            sx={{ mb: 2 }}
            heading={
              isRecurringLock
                ? `Choose payment mode`
                : `Choose payment mode for E-Mandate`
            }
            disableBreadcrumb
            startIcon={
              <IconButton onClick={this.handleBackClick}>
                <BackIcon sx={{ fontSize: 20, color: "#222B3E" }} />
              </IconButton>
            }
          />
          <Grid container justifyContent="space-between">
            <Grid item xs={12} md={5}>
              <Stack
                sx={{
                  filter: !isRecurringCheckBox ? "blur(4px)" : "none",
                  pointerEvents: !isRecurringCheckBox ? "none" : "auto",
                  opacity: !isRecurringCheckBox ? 0.7 : 1,
                }}
              >
                <Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    sx={{ flexWrap: "wrap" }}
                  >
                    {paymentMethods.eligiblePaymentMethods.map((emp, index) => (
                      <Stack
                        key={emp.value}
                        direction="row"
                        alignItems="center"
                        sx={{
                          mr:
                            index ===
                            paymentMethods.eligiblePaymentMethods.length - 1
                              ? 0
                              : 3,
                        }}
                      >
                        <Radio
                          name="paymentMethod"
                          checked={emp.value === formData.paymentMethod}
                          onChange={() =>
                            this.handleFormChange({
                              name: "paymentMethod",
                              value: emp.value,
                            })
                          }
                        />
                        <Text
                          component="label"
                          sx={{
                            color:
                              emp.value === formData.paymentMethod
                                ? "#2B70C5"
                                : "#212225",
                          }}
                        >
                          {emp.label}
                        </Text>
                      </Stack>
                    ))}
                  </Stack>
                  {formError.paymentMethod && (
                    <Text variant="small" sx={{ color: "error.main" }}>
                      {formError.paymentMethod}
                    </Text>
                  )}
                  {selectedPaymentMethodData &&
                  selectedPaymentMethodData.helperText ? (
                    <Stack>
                      <Alert
                        sx={{ my: 1.5 }}
                        icon={
                          <InfoRoundedIcon
                            sx={{ color: "darkgrey", fontSize: "1.125rem" }}
                          />
                        }
                      >
                        <AlertTitle sx={{ mb: 0.2 }}>
                          <Text variant="small">
                            Why {selectedPaymentMethodData.label}?
                          </Text>
                        </AlertTitle>
                        <Text variant="small" sx={{ color: "#5B6871" }}>
                          {selectedPaymentMethodData.helperText}
                        </Text>
                      </Alert>
                    </Stack>
                  ) : null}
                </Stack>
                {formData.paymentMethod === "upi" ? (
                  <>
                    <Stack
                      direction="row"
                      justifyContent="flex-end"
                      onClick={this.handleUpiDrawerOpen}
                    >
                      <Text
                        variant="small"
                        sx={{ color: "#2B70C5", cursor: "pointer" }}
                      >
                        How to find UPI ID?
                      </Text>
                    </Stack>
                    <Stack mt={2} mb={3}>
                      <Stack direction="row">
                        <TextField
                          label="Enter your UPI ID"
                          value={formData.paymentMethodHandle}
                          onChange={(e) =>
                            this.handleFormChange({
                              name: "paymentMethodHandle",
                              value: e.target.value,
                            })
                          }
                          error={formError.paymentMethodHandle}
                          helperText={formError.paymentMethodHandle}
                          InputProps={{ sx: { border: 0 } }}
                        />
                        <JarvisButton
                          size="small"
                          sx={{ marginLeft: "10px", maxHeight: "47px" }}
                          variant="contained"
                          disableEndIcon
                          onClick={this.handleUpiVerification}
                        >
                          Verify
                        </JarvisButton>
                      </Stack>
                      {this.state.verifiedUpi ? (
                        <Stack mt={1} direction="row">
                          <CheckCircleRoundedIcon
                            sx={{
                              fontSize: { xs: "14px", md: "22px" },
                              mt: { xs: "4px", md: "unset" },
                              color: "#45AC70",
                            }}
                          />
                          <Text
                            ml={1}
                            variant="small"
                            sx={{ color: "#45AC70" }}
                          >
                            Verified Successfully
                          </Text>
                        </Stack>
                      ) : null}
                    </Stack>
                  </>
                ) : null}
                {this.isTPVEnabled() ||
                formData.paymentMethod === "emandate" ? (
                  <>
                    <Stack mb={2}>
                      <TextField
                        select
                        label={`Please choose ${selectedPaymentMethodData.label} option`}
                        value={formData.paymentMethodOption}
                        onChange={(e) =>
                          this.handleFormChange({
                            name: "paymentMethodOption",
                            value: e.target.value,
                          })
                        }
                        error={formError.paymentMethodOption}
                        helperText={formError.paymentMethodOption}
                        InputProps={{ sx: { border: 0 } }}
                      >
                        {paymentMethodOptions.map((pmo) => (
                          <MenuItem key={pmo.value} value={pmo.value}>
                            {pmo.label}
                          </MenuItem>
                        ))}
                      </TextField>
                      {selectedMethodOptionData &&
                      selectedMethodOptionData.helperText ? (
                        <Stack>
                          <Alert
                            sx={{ my: 1.5 }}
                            icon={
                              <InfoRoundedIcon
                                sx={{ color: "darkgrey", fontSize: "1.125rem" }}
                              />
                            }
                          >
                            <AlertTitle sx={{ mb: 0.2 }}>
                              <Text variant="small">
                                Note: {selectedMethodOptionData.label}
                              </Text>
                            </AlertTitle>
                            <Text variant="small" sx={{ color: "#5B6871" }}>
                              {selectedMethodOptionData.helperText}
                            </Text>
                          </Alert>
                        </Stack>
                      ) : null}
                    </Stack>
                    <Stack mb={2}>
                      <Stack direction="row">
                        <Text
                          variant="body1"
                          sx={{ fontWeight: "500", mr: 0.5 }}
                        >
                          Account type
                        </Text>
                        <TooltipHover
                          title="According to SEBI guidelines, you should give an eMandate only from your bank account. If it doesn't match your account number, your payment will be declined."
                          sx={{ lineHeight: 0, marginLeft: "3px" }}
                        >
                          <InfoRoundedIcon
                            ml={1}
                            sx={{ width: "20px", color: "#a39e9e" }}
                          />
                        </TooltipHover>
                      </Stack>
                      <Stack
                        direction="row"
                        alignItems="center"
                        sx={{ flexWrap: "wrap", mb: 2 }}
                      >
                        {accountTypes.map((at, index) => (
                          <Stack
                            key={at.value}
                            direction="row"
                            alignItems="center"
                            sx={{
                              mr: index === accountTypes.length - 1 ? 0 : 3,
                            }}
                          >
                            <Radio
                              name="accountType"
                              checked={at.value === formData.accountType}
                              onChange={() =>
                                this.handleFormChange({
                                  name: "accountType",
                                  value: at.value,
                                })
                              }
                            />
                            <Text
                              component="label"
                              sx={{
                                color:
                                  at.value === formData.accountType
                                    ? "#2B70C5"
                                    : "#212225",
                              }}
                            >
                              {at.label}
                            </Text>
                          </Stack>
                        ))}
                      </Stack>
                      <TextField
                        sx={{ mb: 2 }}
                        label="Beneficiary name"
                        value={formData.accountHolderName}
                        onChange={(e) =>
                          this.handleFormChange({
                            name: "accountHolderName",
                            value: e.target.value,
                          })
                        }
                        error={formError.accountHolderName}
                        helperText={formError.accountHolderName}
                      />
                      <TextField
                        sx={{ mb: 2 }}
                        type="number"
                        label="Account number"
                        value={formData.accountNumber}
                        onChange={(e) =>
                          this.handleFormChange({
                            name: "accountNumber",
                            value: e.target.value,
                          })
                        }
                        error={formError.accountNumber}
                        helperText={formError.accountNumber}
                      />
                      <TextField
                        label="IFSC code"
                        value={formData.ifscCode}
                        onChange={(e) =>
                          this.handleFormChange({
                            name: "ifscCode",
                            value: e.target.value,
                          })
                        }
                        error={formError.ifscCode}
                        helperText={formError.ifscCode}
                      />
                    </Stack>
                  </>
                ) : null}
                {formData.paymentMethodOption && authTypeOptions.length ? (
                  <Stack mb={2}>
                    <Text variant="body1" sx={{ fontWeight: "500" }}>
                      Choose verification method for{" "}
                      {selectedPaymentMethodData.label}
                    </Text>
                    <Stack
                      direction="row"
                      alignItems="center"
                      sx={{ flexWrap: "wrap" }}
                    >
                      {authTypeOptions.map((ato, index) => (
                        <Stack
                          key={ato.value}
                          direction="row"
                          alignItems="center"
                          sx={{
                            mr: index === authTypeOptions.length - 1 ? 0 : 3,
                          }}
                        >
                          <Radio
                            name="authType"
                            checked={ato.value === formData.authType}
                            onChange={() =>
                              this.handleFormChange({
                                name: "authType",
                                value: ato.value,
                              })
                            }
                          />
                          <Text
                            component="label"
                            sx={{
                              color:
                                ato.value === formData.authType
                                  ? "#2B70C5"
                                  : "#212225",
                            }}
                          >
                            {ato.label}
                          </Text>
                        </Stack>
                      ))}
                    </Stack>
                  </Stack>
                ) : null}
                <Stack sx={{ mb: 2, display: { xs: "none", md: "flex" } }}>
                  <JarvisButton
                    variant="contained"
                    disabled={
                      formData.paymentMethod === "emandate" ||
                      this.state.verifiedUpi
                        ? false
                        : true
                    }
                    disableEndIcon
                    onClick={
                      this.props.byPassRecurringPayment
                        ? this.handlePayNowByPassRecurring
                        : this.handlePayNow
                    }
                  >
                    Pay {formatHelper.currency(payableAmount)}
                  </JarvisButton>
                </Stack>
                {availablePlans.map((p) => (
                  <Text key={p.id} sx={{ fontSize: "17px" }}>
                    Your {p.planName} subscription auto-renews every{" "}
                    {(
                      planFrequencyLabels[p.planFrequency] || "half-yearly"
                    ).toLowerCase()}
                    .
                    <br /> You can cancel subscription any time.
                  </Text>
                ))}

                <br />
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{ marginTop: { xs: "-20px", sm: "0px" } }}
                >
                  <Checkbox
                    color="#2B70C5"
                    checked={isRecurringCheckBox}
                    onChange={(e) => this.handleCheckBox(e)}
                  />
                  <Text
                    sx={{
                      fontSize: { xs: "13px", sm: "16px" },
                      color: "#747474",
                    }}
                  >
                    I give consent for automatic deductions from my bank account
                    for subscription renewals.
                  </Text>
                </Stack>
              </Stack>
              {isRecurringLock && (
                <Card
                  sx={{
                    textAlign: "center",
                    padding: 5,
                    marginTop: "-100px",
                    zIndex: 100,
                    position: "relative",
                  }}
                >
                  <img src="/svgs/unlock.svg" width={32} height={"auto"} />
                  <Text>Unlock E-Mandate</Text>
                  <Text variant="body2">
                    Enable auto-debit via e-Mandate so your plan renews
                    seamlessly without manual payments.
                  </Text>
                  <br />
                  <JarvisButton
                    disableEndIcon
                    mb={2}
                    onClick={() => this.handleEnableEMandate()}
                    sx={{ fontSize: { xs: "14px", sm: "16px" } }}
                  >
                    Continue with E-Mandate
                  </JarvisButton>
                </Card>
              )}
            </Grid>
            <Dialog
              open={isRecurringModal}
              onClose={() => this.handleEnableEMandate()}
            >
              <DialogTitle sx={{ backgroundColor: "rgba(255, 0, 0, 0.1)" }}>
                <IconButton
                  aria-label="close"
                  onClick={() => this.handleEnableEMandate()}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  x
                </IconButton>
              </DialogTitle>
              <Stack
                sx={{
                  backgroundColor: "rgba(255, 0, 0, 0.1)",
                  padding: "20px",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img src="/svgs/circleBag.svg" width={72} height={"auto"} />
                <br />
                <Text
                  sx={{
                    color: "red",
                    fontSize: { xs: "18px", sm: "20px", md: "22px" },
                  }}
                >
                  Don’t Risk Missing Out E-Mandate!
                </Text>
                <br />
                <Text variant="body2">
                  Your Jarvis subscription ensures you receive timely stock
                  recommendations to grow your portfolio. Skipping the e-mandate
                  setup means a missed renewal and further recommendations
                </Text>
                <br />
                <Text>Do you want to continue?</Text>
                <br />
                <Stack
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: { xs: "stretch", md: "center" },
                    gap: { xs: 1, md: 5 },
                  }}
                >
                  <JarvisButton
                    disableEndIcon
                    variant="outlined"
                    onClick={() => this.SkipForNowHandler()}
                  >
                    Skip for Now
                  </JarvisButton>
                  <JarvisButton
                    disableEndIcon
                    onClick={() => this.handleEnableEMandate()}
                  >
                    Continue with E-Mandate
                  </JarvisButton>
                </Stack>
                <br />
              </Stack>
            </Dialog>
            <Grid item xs={12} md={5}>
              {this.props.enableCouponDiscount &&
              this.state.appliedCouponData.isValid ? (
                <>
                  <CouponCodeRow
                    disableRemoveCoupon={true}
                    onActionTrigger={this.handleCouponAction}
                    viewTypes={couponViewTypes}
                    activeViewType={this.state.couponActiveViewType}
                    formData={this.state.couponFormData}
                    formError={this.state.couponFormError}
                    discountValue={this.state.appliedCouponData.discountPrice}
                    selectedPlanType={selectedPlan}
                    propsValue={this.props}
                  />
                  <Divider sx={{ my: 2 }} />
                </>
              ) : null}
              {this.renderOfferBanner()}
              <Text
                variant="body1"
                sx={{ fontWeight: "medium", mb: { xs: 2, md: 1 } }}
              >
                Price Details
              </Text>
              <PaymentSummary
                selectedPlan={selectedPlan}
                planType={this.getPlanType(selectedPlan?.planFrequency)}
                appliedCouponData={this.state.appliedCouponData}
                paymentType={paymentType}
                upgradePlanAmount={upgradedPlanDiscountedPrice || ""}
              />
              {isRecurringLock && (
                <Stack sx={{ mb: 2, display: { xs: "none", md: "flex" } }}>
                  <JarvisButton
                    variant="contained"
                    disableEndIcon
                    onClick={this.oneTimePaymentHandler}
                  >
                    Pay {formatHelper.currency(payableAmount)}
                  </JarvisButton>
                </Stack>
              )}
              <Stack
                sx={{
                  background: "unset",
                  width: { xs: "100%", md: "unset" },
                  justifyContent: { xs: "center", md: "unset" },
                  alignItems: { xs: "center", md: "unset" },
                }}
              >
                <Stack
                  sx={{
                    position: { xs: "fixed", md: "unset" },
                    bottom: { xs: "10px", md: "unset" },
                    width: { xs: "100%", md: "unset" },
                    backgroundColor: { xs: "unset", md: "none" },
                    padding: { xs: "10px 14px", md: "0px" },
                    paddingBottom: {
                      xs: "calc(var(--safe-area-inset-bottom) + 12px) !important",
                    },
                  }}
                >
                  <MobileResponsive
                    mobile={() => (
                      <JarvisButton
                        variant="contained"
                        disableEndIcon
                        disabled={
                          isRecurringLock
                            ? false
                            : formData.paymentMethod === "emandate" ||
                                this.state.verifiedUpi
                              ? false
                              : true
                        }
                        onClick={
                          this.props.byPassRecurringPayment
                            ? this.handlePayNowByPassRecurring
                            : isRecurringLock
                              ? this.oneTimePaymentHandler
                              : this.handlePayNow
                        }
                      >
                        Pay {formatHelper.currency(payableAmount)}
                      </JarvisButton>
                    )}
                    web={() => <></>}
                  />
                </Stack>
              </Stack>
            </Grid>
          </Grid>
          <UpiDrawer open={upiDrawerOpen} onClose={this.handleUpiDrawerClose} />
        </Stack>
      );
    }

    return <>{activeScreenType} is not defined</>;
  }
}

const style = (theme) => ({
  btns: {
    backgroundColor: "#fff !important",
    color: "#212225",
    border: "1px solid #d3d3d37a",
    padding: "8px 18px",
    marginBottom: "7px",
    marginRight: "7px",
    fontSize: "0.9rem",
    fontWeight: 500,
    minWidth: "11ch",
    boxShadow: "none",
  },
  active: {
    color: "#2B70C5 !important",
    backgroundColor: "#EEF4FA !important",
    border: "0px !important",
  },
  planPrice: {
    lineHeight: "1.1",
    fontSize: "1.5rem",
    fontWeight: "600",
  },
});

PlanPaymentContainer.propTypes = {
  subscriptionPlans: PropTypes.arrayOf(
    PropTypes.shape({
      planId: PropTypes.string,
      planName: PropTypes.string,
      planPrice: PropTypes.number,
      planDiscountedPrice: PropTypes.number,
      planFrequency: PropTypes.string,
      productMap: PropTypes.arrayOf(
        PropTypes.shape({
          productCode: PropTypes.string,
        }),
      ),
      planChecklist: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
  onboardingPlanId: PropTypes.string,
  paymentType: PropTypes.string,
  paymentMethods: PropTypes.shape({
    eligiblePaymentMethods: PropTypes.array,
    eligibleUpiHandles: PropTypes.array,
  }).isRequired,
  enableCouponDiscount: PropTypes.bool,
  getPaymentMethodsAction: PropTypes.func.isRequired,
  getFeatureConfigAction: PropTypes.func.isRequired,
  navigatePreviousScreen: PropTypes.func,
  onPayNowClick: PropTypes.func.isRequired,
  customerProfile: PropTypes.object,
  enableRazorpayTPV: PropTypes.bool,
  byPassRecurringPayment: PropTypes.bool,
  investmentInfo: PropTypes.shape({
    planId: PropTypes.number,
  }),
};

export default withRouter(
  withStyles(style, { withTheme: true })(PlanPaymentContainer),
);
